var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { fromJSON, toJSON } from 'flatted';
import { dereferenceFilesystem } from './dereference';
import { checkIsReference } from './utils';
export { fromJSON, toJSON };
/**
 * Resolve an OpenAPI operation in a file and compile it to a more usable format.
 */
export function resolveOpenAPIOperation(filesystem, operationDescriptor) {
    return __awaiter(this, void 0, void 0, function () {
        var path, method, schema, operation, commonParameters, servers, security, isOptionalSecurity, flatSecurities, securities, _i, flatSecurities_1, entry, securityKey, securityScheme;
        var _a, _b, _c, _d, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    path = operationDescriptor.path, method = operationDescriptor.method;
                    return [4 /*yield*/, dereferenceFilesystem(filesystem)];
                case 1:
                    schema = _g.sent();
                    operation = getOperationByPathAndMethod(schema, path, method);
                    if (!operation) {
                        return [2 /*return*/, null];
                    }
                    commonParameters = getPathObjectParameter(schema, path);
                    if (commonParameters) {
                        operation = __assign(__assign({}, operation), { parameters: __spreadArray(__spreadArray([], commonParameters, true), ((_a = operation.parameters) !== null && _a !== void 0 ? _a : []), true) });
                    }
                    servers = 'servers' in schema ? ((_b = schema.servers) !== null && _b !== void 0 ? _b : []) : [];
                    security = (_d = (_c = operation.security) !== null && _c !== void 0 ? _c : schema.security) !== null && _d !== void 0 ? _d : [];
                    isOptionalSecurity = security.some(function (entry) { return Object.keys(entry).length === 0; });
                    flatSecurities = flattenSecurities(security);
                    securities = [];
                    for (_i = 0, flatSecurities_1 = flatSecurities; _i < flatSecurities_1.length; _i++) {
                        entry = flatSecurities_1[_i];
                        securityKey = Object.keys(entry)[0];
                        if (securityKey) {
                            securityScheme = (_f = (_e = schema.components) === null || _e === void 0 ? void 0 : _e.securitySchemes) === null || _f === void 0 ? void 0 : _f[securityKey];
                            if (securityScheme && !checkIsReference(securityScheme)) {
                                securities.push([
                                    securityKey,
                                    __assign(__assign({}, securityScheme), { required: !isOptionalSecurity }),
                                ]);
                            }
                        }
                    }
                    return [2 /*return*/, {
                            servers: servers,
                            operation: operation,
                            method: method,
                            path: path,
                            securities: securities,
                            'x-codeSamples': typeof schema['x-codeSamples'] === 'boolean' ? schema['x-codeSamples'] : undefined,
                            'x-hideTryItPanel': typeof schema['x-hideTryItPanel'] === 'boolean'
                                ? schema['x-hideTryItPanel']
                                : undefined,
                        }];
            }
        });
    });
}
/**
 * Get a path object from its path.
 */
function getPathObject(schema, path) {
    var _a;
    if ((_a = schema.paths) === null || _a === void 0 ? void 0 : _a[path]) {
        return schema.paths[path];
    }
    return null;
}
/**
 * Resolve parameters from a path in an OpenAPI schema.
 */
function getPathObjectParameter(schema, path) {
    var pathObject = getPathObject(schema, path);
    if (pathObject === null || pathObject === void 0 ? void 0 : pathObject.parameters) {
        return pathObject.parameters;
    }
    return null;
}
/**
 * Get an operation by its path and method.
 */
function getOperationByPathAndMethod(schema, path, method) {
    // Types are buffy for OpenAPIV3_1.OperationObject, so we use v3
    var pathObject = getPathObject(schema, path);
    if (!pathObject) {
        return null;
    }
    var normalizedMethod = method.toLowerCase();
    if (!pathObject[normalizedMethod]) {
        return null;
    }
    return pathObject[normalizedMethod];
}
/**
 * Flatten security objects in case they are nested.
 * @example [{bearerAuth:[], basicAuth:[]}] => [{ bearerAuth: [] }, { basicAuth: [] }]
 */
function flattenSecurities(security) {
    if (!Array.isArray(security) || security.length === 0) {
        return [];
    }
    return security.flatMap(function (securityObject) {
        return Object.entries(securityObject).map(function (_a) {
            var _b;
            var authType = _a[0], config = _a[1];
            return (_b = {},
                _b[authType] = config,
                _b);
        });
    });
}
